import React, { useState, useEffect } from "react";
import confetti from "canvas-confetti"; // 紙吹雪ライブラリをインポート

export default function App() {
  // アプリのデータ
  const phrases = [
    {
      japaneseLanguage: "", // タイトルを空に設定
      language: "英語",
      phrases: [
        {
          type: "どこから来ましたか？",
          text: "Where are you from?",
          pronunciation: "ウェア アー ユー フロム?",
        },
      ],
      isBonus: true,
    },
    {
      japaneseLanguage: "アメリカ/カナダ/ソロモン諸島",
      language: "英語",
      phrases: [
        { type: "ようこそ！", text: "Welcome!", pronunciation: "ウェルカム!" },
        { type: "こんにちは", text: "Hello!", pronunciation: "ハロー!" },
        {
          type: "会えてうれしい",
          text: "Nice to meet you.",
          pronunciation: "ナイス トゥー ミーチュー",
        },
        { type: "ありがとう", text: "Thank you", pronunciation: "サンキュー" },
        {
          type: "愛してる！",
          text: "We love you!",
          pronunciation: "ウィー ラブ ユー!",
        },
        { type: "さようなら", text: "Goodbye", pronunciation: "グッバイ" },
      ],
    },
    {
      japaneseLanguage: "ポーランド",
      language: "ポーランド語",
      phrases: [
        { type: "ようこそ！", text: "Witamy!", pronunciation: "ヴィタミー!" },
        {
          type: "こんにちは",
          text: "Dzień dobry",
          pronunciation: "ジェン ドーブリー",
        },
        {
          type: "会えてうれしい",
          text: "Miło nam cię poznać",
          pronunciation: "ミウォ ナム チエン ポズナチ",
        },
        { type: "ありがとう", text: "Dziękuję", pronunciation: "ジェンクイェ" }, // Modified to singular
        {
          type: "愛してる！",
          text: "Kochamy cię!",
          pronunciation: "コハミー チエン!",
        },
        {
          type: "さようなら",
          text: "Do widzenia",
          pronunciation: "ド ヴィゼニャ",
        },
      ],
    },
    {
      japaneseLanguage: "インド",
      language: "ヒンディー語",
      phrases: [
        {
          type: "ようこそ！",
          text: "स्वागत",
          pronunciation: "スワーガット",
          originalScript: "स्वागत",
        },
        {
          type: "こんにちは",
          text: "नमस्ते",
          pronunciation: "ナマステ",
          originalScript: "नमस्ते",
        },
        {
          type: "会えてうれしい",
          text: "हमें आपसे मिलकर खुशी हुई",
          pronunciation: "ハム アープセ ミルカル クシー フイ",
          originalScript: "हमें आपसे मिलकर खुशी हुई",
        },
        {
          type: "ありがとう",
          text: "धन्यवाद",
          pronunciation: "ダンニャワード",
          originalScript: "धन्यवाद",
        },
        {
          type: "愛してる！",
          text: "हम आप सभी से प्यार करते हैं!",
          pronunciation: "ハム アープ サビー セ ピャール カルテ ヘイン!",
          originalScript: "हम आप सभी से प्यार करते हैं!",
        },
        {
          type: "さようなら",
          text: "नमस्ते",
          pronunciation: "ナマステ",
          originalScript: "नमस्ते",
        },
      ],
    },
    {
      japaneseLanguage: "ルーマニア",
      language: "ルーマニア語",
      phrases: [
        {
          type: "ようこそ！",
          text: "Bine ați venit!",
          pronunciation: "ビネ アツ ヴェニート!",
        },
        {
          type: "こんにちは",
          text: "Bună ziua",
          pronunciation: "ブーナ ジウア",
        },
        {
          type: "会えてうれしい",
          text: "Ne pare bine să vă cunosc",
          pronunciation: "ネ パレ ビネ サ ヴァ クノスク",
        },
        {
          type: "ありがとう",
          text: "Mulțumesc",
          pronunciation: "ムルツメスク",
        },
        {
          type: "愛してる！",
          text: "Vă iubim!",
          pronunciation: "ヴァ ユビム!",
        },
        {
          type: "さようなら",
          text: "La revedere",
          pronunciation: "ラ レヴェデーレ",
        },
      ],
    },
    {
      japaneseLanguage: "韓国",
      language: "韓国語",
      phrases: [
        {
          type: "ようこそ！",
          text: "환영합니다",
          pronunciation: "ファニョンハムニダ",
        },
        {
          type: "こんにちは",
          text: "안녕하세요",
          pronunciation: "アンニョンハセヨ",
        },
        {
          type: "会えてうれしい",
          text: "만나서 반갑습니다",
          pronunciation: "マンナソ パンガプスムニダ",
        },
        {
          type: "ありがとう",
          text: "감사합니다",
          pronunciation: "カムサハムニダ",
        },
        { type: "愛してる！", text: "사랑해요!", pronunciation: "サランヘヨ!" },
        {
          type: "さようなら",
          text: "안녕히 계세요",
          pronunciation: "アンニョンヒ ゲセヨ",
        },
      ],
    },
    {
      japaneseLanguage: "スペイン/エクアドル",
      language: "スペイン語",
      phrases: [
        {
          type: "ようこそ！",
          text: "¡Bienvenidos!",
          pronunciation: "ビエンベニードス!",
        },
        { type: "こんにちは", text: "¡Hola!", pronunciation: "オーラ!" },
        {
          type: "会えてうれしい",
          text: "Mucho gusto",
          pronunciation: "ムーチョ グースト",
        },
        { type: "ありがとう", text: "Gracias", pronunciation: "グラシアス" },
        {
          type: "愛してる！",
          text: "¡Los queremos mucho!",
          pronunciation: "ロス ケレモス ムーチョ!",
        }, // Modified
        { type: "さようなら", text: "Adiós", pronunciation: "アディオス" },
      ],
    },
    {
      japaneseLanguage: "フィリピン",
      language: "タガログ語",
      phrases: [
        {
          type: "ようこそ！",
          text: "Maligayang pagdating!",
          pronunciation: "マリガヤン パグダティン!",
        }, // Modified
        { type: "こんにちは", text: "Kumusta", pronunciation: "クムスタ" },
        {
          type: "会えてうれしい",
          text: "Ikinagagalak namin kayong makilala",
          pronunciation: "イキナガガラック ナミン カヨン マキラーラ",
        },
        { type: "ありがとう", text: "Salamat", pronunciation: "サラマッ" },
        {
          type: "愛してる！",
          text: "Mahal ka namin!",
          pronunciation: "マハル カ ナミン!",
        }, // Modified
        { type: "さようなら", text: "Paalam", pronunciation: "パーラム" },
      ],
    },
  ];

  // クイズ用のデータから番外編を除外
  const quizPhrases = phrases.filter((p) => !p.isBonus);

  // ステート管理
  const [mode, setMode] = useState("study"); // 'study' or 'test'
  const [selectedLanguage, setSelectedLanguage] = useState(phrases[0]);

  // おためしモード用のステート
  const [score, setScore] = useState(0);
  const [questionCount, setQuestionCount] = useState(0);
  const [isCorrect, setIsCorrect] = useState(null);
  const [options, setOptions] = useState([]);
  const [currentQuestionPhrase, setCurrentQuestionPhrase] = useState({});
  const [quizActive, setQuizActive] = useState(true); // クイズがアクティブかどうか
  const [showAnswerFeedback, setShowAnswerFeedback] = useState(false); // 解答フィードバック表示中か
  const [selectedOption, setSelectedOption] = useState(null); // ユーザーが選択したオプション
  const [quizHistory, setQuizHistory] = useState([]); // クイズの履歴を保存
  const [encouragementMessage, setEncouragementMessage] = useState(""); // 褒め言葉のステート

  // 褒め言葉のリスト
  const encouragingMessages = [
    "頑張りましたね！",
    "素晴らしい結果です！",
    "よくできました！",
    "お疲れ様でした！",
    "次も頑張りましょう！",
    "学習の成果が出ていますね！",
    "素晴らしい集中力でした！",
    "着実に力がついています！",
  ];

  // 音声再生関数
  const playAudio = (textToSpeak, language) => {
    if ("speechSynthesis" in window) {
      // 既存の音声をキャンセルして二重再生を防ぐ
      window.speechSynthesis.cancel();

      const utterance = new SpeechSynthesisUtterance(textToSpeak);

      // 言語コードを設定 (より正確な発音のため)
      let langCode = "";
      switch (language) {
        case "英語":
          langCode = "en-US";
          break;
        case "ポーランド語":
          langCode = "pl-PL";
          break;
        case "ヒンディー語":
          langCode = "hi-IN";
          break;
        case "ルーマニア語":
          langCode = "ro-RO";
          break;
        case "韓国語":
          langCode = "ko-KR";
          break;
        case "スペイン語":
          langCode = "es-MX"; // メキシコスペイン語に変更（よりクリア）
          break;
        case "タガログ語":
          langCode = "tl-PH";
          break;
        default:
          langCode = "en-US"; // デフォルトは英語
      }
      utterance.lang = langCode;

      // 音質向上のための設定
      utterance.rate = 0.9; // 少し遅めに話す
      utterance.pitch = 1.1; // 少し高めのピッチ
      utterance.volume = 1.0; // 最大音量

      // 利用可能な音声が読み込まれていない場合、voiceschangedイベントを待つ
      const setVoice = () => {
        const voices = window.speechSynthesis.getVoices();

        // 女性の声を優先的に選択
        let selectedVoice = null;

        // スペイン語の場合の特別な処理
        if (language === "スペイン語") {
          // スペイン語の音質の良い音声を優先的に探す
          const spanishVoices = voices.filter(
            (voice) =>
              (voice.lang.startsWith("es-") || voice.lang === "es") &&
              (voice.name.toLowerCase().includes("monica") ||
                voice.name.toLowerCase().includes("lucia") ||
                voice.name.toLowerCase().includes("paulina") ||
                voice.name.toLowerCase().includes("sara") ||
                voice.name.toLowerCase().includes("female") ||
                voice.name.toLowerCase().includes("woman") ||
                voice.name.toLowerCase().includes("esperanza") ||
                voice.name.toLowerCase().includes("catalina"))
          );

          // メキシコ系スペイン語を優先
          const mexicanVoices = spanishVoices.filter(
            (voice) => voice.lang === "es-MX" || voice.lang === "es-US"
          );

          if (mexicanVoices.length > 0) {
            selectedVoice = mexicanVoices[0];
          } else if (spanishVoices.length > 0) {
            selectedVoice = spanishVoices[0];
          }
        }

        // 他の言語または스페인어で適切な音声が見つからない場合
        if (!selectedVoice) {
          // まず、指定言語の女性の声を探す
          const femaleVoices = voices.filter(
            (voice) =>
              voice.lang === langCode &&
              (voice.name.toLowerCase().includes("female") ||
                voice.name.toLowerCase().includes("woman") ||
                voice.name.toLowerCase().includes("samantha") ||
                voice.name.toLowerCase().includes("sara") ||
                voice.name.toLowerCase().includes("anna") ||
                voice.name.toLowerCase().includes("zira") ||
                voice.name.toLowerCase().includes("hazel") ||
                voice.name.toLowerCase().includes("karen") ||
                voice.name.toLowerCase().includes("moira") ||
                voice.name.toLowerCase().includes("tessa") ||
                voice.name.toLowerCase().includes("veena") ||
                voice.name.toLowerCase().includes("rishi") ||
                voice.name.toLowerCase().includes("yuna") ||
                voice.name.toLowerCase().includes("kyoko") ||
                voice.name.toLowerCase().includes("sayaka") ||
                voice.name.toLowerCase().includes("helena") ||
                voice.name.toLowerCase().includes("lucia") ||
                voice.name.toLowerCase().includes("paulina") ||
                voice.name.toLowerCase().includes("carmit"))
          );

          if (femaleVoices.length > 0) {
            selectedVoice = femaleVoices[0];
          } else {
            // 女性の声が見つからない場合、指定言語の任意の声を使用
            selectedVoice = voices.find((voice) => voice.lang === langCode);

            if (!selectedVoice) {
              // 指定言語の声が見つからない場合、言語プレフィックスで検索
              const languagePrefix = langCode.split("-")[0];
              const similarLangVoices = voices.filter((voice) =>
                voice.lang.startsWith(languagePrefix)
              );

              if (similarLangVoices.length > 0) {
                // より高品質な音声を優先（通常、地域指定がある方が高品質）
                selectedVoice =
                  similarLangVoices.find((voice) => voice.lang.includes("-")) ||
                  similarLangVoices[0];
              }

              if (!selectedVoice) {
                // それでも見つからない場合、英語の女性の声を探す
                const englishFemaleVoices = voices.filter(
                  (voice) =>
                    voice.lang.startsWith("en") &&
                    (voice.name.toLowerCase().includes("female") ||
                      voice.name.toLowerCase().includes("samantha") ||
                      voice.name.toLowerCase().includes("sara") ||
                      voice.name.toLowerCase().includes("anna") ||
                      voice.name.toLowerCase().includes("zira") ||
                      voice.name.toLowerCase().includes("hazel") ||
                      voice.name.toLowerCase().includes("karen") ||
                      voice.name.toLowerCase().includes("moira") ||
                      voice.name.toLowerCase().includes("tessa"))
                );

                if (englishFemaleVoices.length > 0) {
                  selectedVoice = englishFemaleVoices[0];
                } else {
                  // 最後の手段：任意の英語の声
                  selectedVoice = voices.find((voice) =>
                    voice.lang.startsWith("en")
                  );
                }
              }
            }
          }
        }

        if (selectedVoice) {
          utterance.voice = selectedVoice;
          console.log(
            `Selected voice: ${selectedVoice.name} (${selectedVoice.lang})`
          );
        }

        window.speechSynthesis.speak(utterance);
      };

      if (window.speechSynthesis.getVoices().length === 0) {
        window.speechSynthesis.onvoiceschanged = setVoice;
      } else {
        setVoice();
      }
    } else {
      console.warn("Web Speech API is not supported in this browser.");
    }
  };

  // ランダムな質問を生成
  const generateNewQuestion = () => {
    // クイズ用のデータから質問する言語をランダムに選択
    const newIndex = Math.floor(Math.random() * quizPhrases.length);
    const newSelectedLanguage = quizPhrases[newIndex];
    setSelectedLanguage(newSelectedLanguage);

    // 質問するフレーズをランダムに選択
    const newPhraseIndex = Math.floor(
      Math.random() * newSelectedLanguage.phrases.length
    );
    const newPhrase = newSelectedLanguage.phrases[newPhraseIndex];
    setCurrentQuestionPhrase(newPhrase);

    // 選択肢を生成（「フレーズ (読み方)」の形式）
    const getFormattedPhrase = (phrase) => {
      // ヒンディー語の場合、元の文字と読み方を両方表示
      if (phrase.originalScript) {
        return `${phrase.originalScript} (${phrase.pronunciation})`;
      }
      return `${phrase.text} (${phrase.pronunciation})`;
    };

    const correctAnswer = getFormattedPhrase(newPhrase);
    const newOptions = [correctAnswer];

    // 挨拶と歓迎の言葉を混在させて選択肢を生成
    while (newOptions.length < 4) {
      const randomIndex = Math.floor(Math.random() * phrases.length);
      const randomPhraseIndex = Math.floor(
        Math.random() * phrases[randomIndex].phrases.length
      );
      const randomPhrase = getFormattedPhrase(
        phrases[randomIndex].phrases[randomPhraseIndex]
      );

      if (!newOptions.includes(randomPhrase)) {
        newOptions.push(randomPhrase);
      }
    }
    // 選択肢をシャッフル
    setOptions(newOptions.sort(() => Math.random() - 0.5));
    setIsCorrect(null);
    setSelectedOption(null); // 新しい問題で選択状態をリセット
  };

  useEffect(() => {
    if (mode === "test") {
      setQuizActive(true); // テストモードに入ったらクイズをアクティブにする
      generateNewQuestion();
      setScore(0);
      setQuestionCount(0);
      setShowAnswerFeedback(false);
      setQuizHistory([]); // クイズ開始時に履歴をリセット
      setEncouragementMessage(""); // クイズ開始時に褒め言葉をリセット
    }
  }, [mode]);

  // おためしモードの回答をチェック
  const handleAnswer = (answer) => {
    if (showAnswerFeedback) return; // フィードバック表示中は回答を受け付けない

    setSelectedOption(answer); // 選択したオプションを保存

    const correctAnswer = `${
      currentQuestionPhrase.originalScript || currentQuestionPhrase.text
    } (${currentQuestionPhrase.pronunciation})`;
    const isAnswerCorrect = answer === correctAnswer;
    setIsCorrect(isAnswerCorrect);
    if (isAnswerCorrect) {
      setScore((prevScore) => prevScore + 1);
      // 正解時の短い紙吹雪
      confetti({
        particleCount: 50,
        spread: 70,
        origin: { y: 0.6 },
      });
    }
    // 正解の選択肢を読み上げる (正解・不正解にかかわらず)
    playAudio(correctAnswer, selectedLanguage.language);

    setQuestionCount((prevCount) => prevCount + 1);
    setShowAnswerFeedback(true); // 解答フィードバックを表示

    // クイズ履歴に追加
    setQuizHistory((prevHistory) => [
      ...prevHistory,
      {
        questionLanguage: selectedLanguage.japaneseLanguage,
        questionType: currentQuestionPhrase.type,
        correctAnswer: correctAnswer,
        userAnswer: answer,
        isCorrect: isAnswerCorrect,
      },
    ]);
  };

  // 「わからない」ボタンのハンドラー
  const handlePassQuestion = () => {
    if (showAnswerFeedback) return; // フィードバック表示中はパスできない

    setQuestionCount((prevCount) => prevCount + 1); // 回数だけカウント
    setIsCorrect(false); // 不正解として扱うが、フィードバックは表示しない
    setSelectedOption("スキップ"); // 履歴用にスキップを記録

    // クイズ履歴に追加
    setQuizHistory((prevHistory) => [
      ...prevHistory,
      {
        questionLanguage: selectedLanguage.japaneseLanguage,
        questionType: currentQuestionPhrase.type,
        correctAnswer: `${
          currentQuestionPhrase.originalScript || currentQuestionPhrase.text
        } (${currentQuestionPhrase.pronunciation})`,
        userAnswer: "スキップ",
        isCorrect: false, // スキップは不正解として記録
      },
    ]);

    // 次の質問へ進む
    if (questionCount >= 5) {
      confetti({
        particleCount: 200,
        spread: 180,
        startVelocity: 30,
        scalar: 0.9,
        decay: 0.92,
        gravity: 1,
        ticks: 200,
        origin: { y: 0.5, x: 0.5 },
      });
      setQuizActive(false); // クイズ終了
      // 褒め言葉をランダムに選択
      const randomIndex = Math.floor(
        Math.random() * encouragingMessages.length
      );
      setEncouragementMessage(encouragingMessages[randomIndex]);
    } else {
      generateNewQuestion(); // 次の問題を生成
    }
    setShowAnswerFeedback(false); // フィードバックを非表示にする
    setSelectedOption(null); // 選択状態をリセット
  };

  // 次の問題へ進む、またはクイズを終了する
  const handleNextQuestion = () => {
    setShowAnswerFeedback(false); // フィードバックを非表示にする
    if (questionCount >= 5) {
      // クイズ終了時の盛大な紙吹雪
      confetti({
        particleCount: 200,
        spread: 180,
        startVelocity: 30,
        scalar: 0.9,
        decay: 0.92,
        gravity: 1,
        ticks: 200,
        origin: { y: 0.5, x: 0.5 },
      });
      setQuizActive(false); // クイズ終了
      // 褒め言葉をランダムに選択
      const randomIndex = Math.floor(
        Math.random() * encouragingMessages.length
      );
      setEncouragementMessage(encouragingMessages[randomIndex]);
    } else {
      generateNewQuestion(); // 次の問題を生成
    }
  };

  // クイズをやり直す
  const handleRestartQuiz = () => {
    setQuizActive(true);
    setScore(0);
    setQuestionCount(0);
    setEncouragementMessage(""); // クイズやり直し時に褒め言葉をリセット
    generateNewQuestion();
    setShowAnswerFeedback(false);
    setQuizHistory([]); // クイズをやり直す際に履歴もリセット
  };

  // UIコンポーネント
  const ModeSelector = () => (
    <div className="flex gap-4 p-4 justify-center">
      <button
        onClick={() => setMode("study")}
        className={`px-6 py-2 rounded-full font-bold transition-all duration-300 transform hover:scale-105 shadow-lg
          ${
            mode === "study"
              ? "bg-indigo-600 text-white"
              : "bg-gray-200 text-gray-800"
          }`}
      >
        あいさつ帳
      </button>
      <button
        onClick={() => setMode("test")}
        className={`px-6 py-2 rounded-full font-bold transition-all duration-300 transform hover:scale-105 shadow-lg
          ${
            mode === "test"
              ? "bg-indigo-600 text-white"
              : "bg-gray-200 text-gray-800"
          }`}
      >
        おためし
      </button>
    </div>
  );

  const PhraseListMode = () => (
    <div className="flex flex-col items-center w-full p-4">
      {phrases.map((phrase, index) => (
        <div
          key={index}
          className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-full text-center mb-6"
        >
          {!phrase.isBonus && (
            <>
              <p className="text-sm text-gray-500 mb-2">地域・言語</p>
              <h2 className="text-4xl font-extrabold text-gray-900 mb-6">
                {phrase.japaneseLanguage} ({phrase.language})
              </h2>
            </>
          )}
          {phrase.isBonus && (
            // 番外編のカードではタイトル部分を非表示にする
            <div className="h-10"></div> // タイトル分のスペースを確保（任意）
          )}
          <div className="space-y-6">
            {phrase.phrases.map((item, itemIndex) => (
              <div key={itemIndex}>
                <p className="text-xl text-gray-600">{item.type}</p>
                <button
                  onClick={() =>
                    playAudio(
                      phrase.language === "ヒンディー語"
                        ? item.originalScript
                        : item.text,
                      phrase.language
                    )
                  }
                  className="flex items-center justify-center space-x-2 text-5xl font-bold text-indigo-600 mt-2 p-2 rounded-lg hover:bg-indigo-50 transition-colors w-full"
                >
                  <span>
                    {phrase.language === "ヒンディー語"
                      ? item.originalScript
                      : item.text}
                  </span>
                  <span
                    role="img"
                    aria-label="speaker icon"
                    className="text-3xl"
                  >
                    🔊
                  </span>
                </button>
                <p className="text-2xl text-gray-400 mt-1">
                  ({item.pronunciation})
                </p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );

  const QuizMode = () => {
    const correctAnswerText = `${
      currentQuestionPhrase.originalScript || currentQuestionPhrase.text
    } (${currentQuestionPhrase.pronunciation})`;

    return (
      <div className="flex flex-col items-center">
        {quizActive ? (
          // クイズがアクティブな場合
          <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-full text-center">
            {/* スコアではなく進捗を表示 */}
            <p className="text-lg font-bold text-gray-600 mb-2">
              {questionCount} / 5問
            </p>
            <p className="text-2xl font-extrabold text-gray-800 mb-8">
              {selectedLanguage.japaneseLanguage}の{currentQuestionPhrase.type}
              はどれですか？
            </p>
            {/* Feedback area with fixed height to prevent layout shift */}
            <div className="h-10 flex items-center justify-center mb-4">
              {showAnswerFeedback && (
                <p
                  className={`text-2xl font-bold
                  ${isCorrect ? "text-green-500" : "text-red-500"}`}
                >
                  {isCorrect ? "正解！" : "残念、不正解..."}
                </p>
              )}
            </div>
            <div className="flex flex-col gap-4">
              {options.map((option, index) => (
                <button
                  key={index}
                  onClick={() => handleAnswer(option)}
                  className={`
                    px-4 py-3 text-gray-800 font-bold rounded-lg shadow-md
                    transition-all duration-200 text-lg
                    border-2 border-transparent  // デフォルトで透明な枠線を追加
                    ${
                      !showAnswerFeedback ? "hover:bg-gray-200 bg-gray-100" : ""
                    }
                    ${showAnswerFeedback ? "cursor-not-allowed" : ""}

                    // 正解の緑枠と背景
                    ${
                      showAnswerFeedback && option === correctAnswerText
                        ? "border-green-500 bg-green-100 opacity-100" // 濃い背景色
                        : ""
                    }
                    // 不正解の赤枠と背景 (かつ、選択したオプションである場合)
                    ${
                      showAnswerFeedback &&
                      !isCorrect &&
                      option === selectedOption &&
                      selectedOption !== "スキップ"
                        ? "border-red-500 bg-red-100 opacity-100 shake-animation" // shake-animationを追加
                        : ""
                    }
                    // その他の選択肢は薄く表示
                    ${
                      showAnswerFeedback &&
                      option !== correctAnswerText &&
                      option !== selectedOption
                        ? "opacity-50 bg-gray-50" // 薄い背景色
                        : ""
                    }
                  `}
                  disabled={showAnswerFeedback} // フィードバック表示中はボタンを無効化
                >
                  {option}
                </button>
              ))}
            </div>
            {showAnswerFeedback ? ( // 解答フィードバック表示中のみ「次へ」ボタンを表示
              <button
                onClick={handleNextQuestion}
                className="mt-8 px-8 py-3 bg-indigo-500 text-white font-bold rounded-full shadow-lg hover:bg-indigo-700 transition-colors duration-300 transform hover:scale-105"
              >
                次へ
              </button>
            ) : (
              // 解答前は「わからない」ボタンを表示
              <button
                onClick={handlePassQuestion}
                className="mt-8 px-8 py-3 bg-gray-400 text-white font-bold rounded-full shadow-lg hover:bg-gray-600 transition-colors duration-300 transform hover:scale-105"
              >
                わからない
              </button>
            )}
          </div>
        ) : (
          // クイズ終了画面
          <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-full text-center">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-6">
              クイズ終了！
            </h2>
            <p className="text-3xl font-bold text-indigo-600 mb-4">
              スコア: {score} / {questionCount}
            </p>
            {encouragementMessage && (
              <p className="text-2xl font-semibold text-gray-700 mb-8">
                {encouragementMessage}
              </p>
            )}

            {/* クイズ結果一覧の表示 */}
            <div className="text-left mt-8 space-y-4 max-h-80 overflow-y-auto p-2 border border-gray-200 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-700 mb-4 text-center">
                解答結果
              </h3>
              {quizHistory.map((item, idx) => (
                <div
                  key={idx}
                  className="mb-4 p-3 border-b border-gray-100 last:border-b-0"
                >
                  <p className="font-semibold text-gray-800">
                    <span className="text-indigo-600">Q{idx + 1}:</span>{" "}
                    {item.questionLanguage}の{item.questionType}はどれですか？
                  </p>
                  <p
                    className={`mt-1 ${
                      item.isCorrect
                        ? "text-green-600"
                        : item.userAnswer === "スキップ"
                        ? "text-gray-500"
                        : "text-red-600"
                    }`}
                  >
                    あなたの解答: {item.userAnswer}{" "}
                    {item.isCorrect
                      ? " (正解)"
                      : item.userAnswer === "スキップ"
                      ? " (スキップ)"
                      : " (不正解)"}
                  </p>
                  {!item.isCorrect && item.userAnswer !== "スキップ" && (
                    <p className="text-green-600">正解: {item.correctAnswer}</p>
                  )}
                  {item.userAnswer === "スキップ" && (
                    <p className="text-gray-600">正解: {item.correctAnswer}</p>
                  )}
                </div>
              ))}
            </div>

            <button
              onClick={handleRestartQuiz}
              className="mt-8 px-8 py-3 bg-indigo-500 text-white font-bold rounded-full shadow-lg hover:bg-indigo-700 transition-colors duration-300 transform hover:scale-105"
            >
              もう一度やり直す
            </button>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-start font-sans p-4 overflow-x-hidden">
      {/* CSS for shake animation */}
      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
          20%, 40%, 60%, 80% { transform: translateX(5px); }
        }

        .shake-animation {
          animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
        }
      `}</style>
      <h1 className="text-center text-4xl font-extrabold text-gray-800 my-8">
        世界あいさつ帳
      </h1>
      <ModeSelector />
      <hr className="my-6 border-gray-200 w-full" />
      {mode === "study" ? <PhraseListMode /> : <QuizMode />}
    </div>
  );
}
